import { CONTENT_HEADING } from "../../constants";
import Content from "../global/Content";
import { useNavigate,Link } from "react-router-dom";

const Seo = () => {
	const navigate = useNavigate();
	const handleRedirect = (e, path = "/registration") => {
		e.preventDefault();
		window.scroll({ top: 0, behavior: "smooth" });
		navigate(path);
	  };
  const token = localStorage.getItem("usertoken");
	return (
		
		<Content title="Artificial Intelligence">
			<p className='pera-text tagp'>
				Generative AI tools cannot be named as authors or co-authors.
			</p>
			<p className='pera-text tagp'>
				Authors remain fully responsible for all content created or edited with an AI tool, including its:
			</p>
			<ul className="tagul">
				<li className="tagli">Accuracy</li>
				<li className="tagli">Originality</li>
				<li className="tagli">Citations and references</li>
				<li className="tagli">Data and analysis</li>
				<li className="tagli">Figures and other visual material</li>
			</ul>
			<p className='pera-text tagp'>
				Any substantive use of generative AI must be disclosed in the Acknowledgements and, where relevant, in the Methods section. The disclosure should identify the tool, model or version and explain how it was used.
			</p>
			<p className='pera-text tagp'>
				AI-generated references, quotations, facts and images must be independently verified before submission. Our system detects anomalies and once spotted, will not allow the article to be processed any further. You will then have to make suitable changes and resubmit.
			</p>
		</Content>
	 
	);
};

export default Seo;
